import { render } from "./AdminListingEdit.vue?vue&type=template&id=6a1dae2f"
import script from "./AdminListingEdit.vue?vue&type=script&lang=js"
export * from "./AdminListingEdit.vue?vue&type=script&lang=js"
script.render = render

export default script